var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elite-tabs-wrapper-content"},[_c('h3',{staticClass:"mb-4"},[_vm._v(" "+_vm._s(_vm.organization.name)+" - "+_vm._s(_vm.$t("ORGANIZATIONS.AUTHORIZATIONS"))+" ")]),_c('permissions-table',{attrs:{"permissionsData":_vm.organization.activePermissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }